import { ReactNode } from 'react';
import { Button } from '../ui/Button';
import { useTranslation } from '../lib/i18n/TranslationContext';

const Card = ({ children }: { children: ReactNode }) => {
	return <div className='bg-gray-50 p-6 flex flex-col gap-2 rounded-xl w-full max-w-[482px] min-h-[156px] grow basis-[482px]'>{children}</div>;
};

const CentralAjuda = ({ href }: { href: string }) => {
	const { t } = useTranslation();

	return (
		<>
			<div className='w-full flex flex-row gap-4 items-center justify-center flex-wrap'>
				<Card>
					<h1 className='text-gray-900 text-sm font-medium leading-5'>{t('Verifique a central de ajuda')}</h1>
					<p className='text-gray-600 text-sm font-normal leading-5'>{t('Tire suas dúvidas na nossa central unificada de suporte. Se precisar de mais ajudar, fale conosco no WhatsApp.')}</p>
					<Button className='w-fit border-gray-200 bg-white' variant='outline' asChild>
						<a href={href} target='_blank'>
							{t('Obter ajuda')}
						</a>
					</Button>
				</Card>
				<Card>
					<h1 className='text-gray-900 text-sm font-medium leading-5'>{t('Estamos aqui 7 dias na semana')}</h1>
					<p className='text-gray-600 text-sm font-normal leading-5'>{t('Agende uma reunião com nossos experts e receba demonstrações dos apps ao vivo.')}</p>
					<Button asChild className='w-fit border-gray-200 bg-white' variant='outline'>
						<a href={t('https://empreender.expert/')} target='_blank'>
							{t('Contate-nos')}
						</a>
					</Button>
				</Card>
			</div>
		</>
	);
};

export default CentralAjuda;
